import React, { useState, useEffect, useRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useMutation, useManualQuery } from "graphql-hooks";
import {
  Box,
  Grid,
  Stack,
  Typography,
  Chip,
  IconButton,
  InputLabel,
  TextField,
  Button,
  Paper,
  Divider,
  Avatar,
  Tooltip,
  Card,
  CardMedia,
  CardHeader,
  CardContent,
  CardActions,
  MenuItem,
  Select,
  FormControl,
  Drawer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Link,
  Collapse,
  useMediaQuery,
} from "@mui/material";
import ReactPlayer from "react-player";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCartOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import AlertPopup from "../components/AlertPopup";

import UserCard from "./UserCard";
import FollowButton from "./FollowButton";
import LikesPopup from "./LikesPopup";
import SharePopup from "./SharePopup";
import CommentDialog from "./CommentDialog";

import { 
  CREATE_FOLLOW_MUTATION,
  DELETE_FOLLOW_MUTATION 
} from "../graphQL/follow_qry";

import { 
  CREATE_TOY_LIKE_MUTATION,
  DELETE_TOY_LIKE_MUTATION,
  UPDATE_TOY_SHARE_NO_BY_UUID,
  CREATE_TOY_COMMENT_MUTATION,
  DELETE_TOY_COMMENT_MUTATION,
  EDIT_TOY_COMMENT_MUTATION,
  CREATE_TOY_COMMENT_LIKE_MUTATION,
  DELETE_TOY_COMMENT_LIKE_MUTATION,
  CREATE_TOY_COMMENT_REPLY_MUTATION,
  DELETE_TOY_COMMENT_REPLY_MUTATION,
  EDIT_TOY_COMMENT_REPLY_MUTATION,
  CREATE_TOY_COMMENT_REPLY_LIKE_MUTATION,
  DELETE_TOY_COMMENT_REPLY_LIKE_MUTATION,
} from "../graphQL/toy_qry";

import { 
  CREATE_STORY_LIKE_MUTATION,
  DELETE_STORY_LIKE_MUTATION,
  UPDATE_STORY_SHARE_NO,
  CREATE_STORY_COMMENT_MUTATION,
  DELETE_STORY_COMMENT_MUTATION,
  EDIT_STORY_COMMENT_MUTATION,
  CREATE_STORY_COMMENT_LIKE_MUTATION,
  DELETE_STORY_COMMENT_LIKE_MUTATION,
  CREATE_STORY_COMMENT_REPLY_MUTATION,
  DELETE_STORY_COMMENT_REPLY_MUTATION,
  EDIT_STORY_COMMENT_REPLY_MUTATION,
  CREATE_STORY_COMMENT_REPLY_LIKE_MUTATION,
  DELETE_STORY_COMMENT_REPLY_LIKE_MUTATION,
} from "../graphQL/story_qry";

import { 
  CREATE_VIDEO_LIKE_MUTATION,
  DELETE_VIDEO_LIKE_MUTATION,
  UPDATE_VIDEO_SHARE_NO,
  CREATE_VIDEO_COMMENT_MUTATION,
  DELETE_VIDEO_COMMENT_MUTATION,
  EDIT_VIDEO_COMMENT_MUTATION,
  CREATE_VIDEO_COMMENT_LIKE_MUTATION,
  DELETE_VIDEO_COMMENT_LIKE_MUTATION,
  CREATE_VIDEO_COMMENT_REPLY_MUTATION,
  DELETE_VIDEO_COMMENT_REPLY_MUTATION,
  EDIT_VIDEO_COMMENT_REPLY_MUTATION,
  CREATE_VIDEO_COMMENT_REPLY_LIKE_MUTATION,
  DELETE_VIDEO_COMMENT_REPLY_LIKE_MUTATION,
} from "../graphQL/video_qry";

//Tooltip Component
const StyledTooltip = ({ title, children }) => (
  <Tooltip
    title={title}
    placement="top"
    arrow
    PopperProps={{
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, -5],
          },
        },
      ],
    }}
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: "#666",
          color: "white",
          fontSize: "12px",
          fontWeight: "500",
          borderRadius: "4px",
          padding: "6px 8px",
          "& .MuiTooltip-arrow": {
            color: "#666",
          },
        },
      },
    }}
  >
    {children}
  </Tooltip>
);

function TruncatedTooltip({ title, children }) {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = () => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(
        el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth
      );
    }
  };

  useEffect(() => {
    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [title, children]);

  const content = (
    <Typography
      ref={textRef}
      variant="body2"
      sx={{
        fontWeight: "bold",
        color: "black",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        minHeight: "2.8em",
        lineHeight: "1.4em",
        cursor: "default",
      }}
    >
      {children}
    </Typography>
  );

  return isTruncated ? (
    <Tooltip
      title={title}
      placement="top"
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -5],
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#666",
            color: "white",
            fontSize: "12px",
            fontWeight: "500",
            borderRadius: "4px",
            padding: "6px 8px",
            "& .MuiTooltip-arrow": {
              color: "#666",
            },
          },
        },
      }}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
}

const ProductCard = ({
  p, 
  onBookmarkClick, 
  onUserProfileNavigation, 
  onFollowToggle,
  onShareClick,
}) => {


  const [isFavorited, setIsFavorited] = useState(p.isLiked);
  const [likeCount, setLikeCount] = useState(p.likes);
  const [commentCount, setCommentCount] = useState(p.commentNo);
  const [isFollowing, setIsFollowing] = useState(p.userId.isFollowing);
  const [isBookmarked, setIsBookmarked] = useState(p.isInCollection);
  const [shareDialog, setShareDialog] = useState({ open: false });
  const [product, setProduct] = useState(p);
  const [unfollowPopup, setUnfollowPopup] = useState({
    open: false,
    followerId: null,
    followerName: "",
  });
  const [commentDialog, setCommentDialog] = useState({
    open: false
  });

  let userUuid = localStorage.getItem("userUuid") ? localStorage.getItem("userUuid") : null;

  // Sync with prop changes when parent updates the follow state

  useEffect(() => {
    setProduct(p);
  }, [p]);

  useEffect(() => {
    setIsFollowing(product.userId.isFollowing);
  }, [product.userId.isFollowing]);

  useEffect(() => {
    setIsBookmarked(product.isInCollection);
  }, [product.isInCollection]);  

  const [createFollow] = useMutation(CREATE_FOLLOW_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unFollow] = useMutation(DELETE_FOLLOW_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createToyLike] = useMutation(CREATE_TOY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeToy] = useMutation(DELETE_TOY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [updateToyShare] = useMutation(UPDATE_TOY_SHARE_NO_BY_UUID, {
    awaitRefetchQueries: true,
  });

  const [createToyComment] = useMutation(CREATE_TOY_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [editToyComment] = useMutation(EDIT_TOY_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteToyComment] = useMutation(DELETE_TOY_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createToyCommentLike] = useMutation(CREATE_TOY_COMMENT_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeToyComment] = useMutation(DELETE_TOY_COMMENT_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createToyCommentReply] = useMutation(CREATE_TOY_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [editToyCommentReply] = useMutation(EDIT_TOY_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteToyCommentReply] = useMutation(DELETE_TOY_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createToyCommentReplyLike] = useMutation(CREATE_TOY_COMMENT_REPLY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeToyCommentReply] = useMutation(DELETE_TOY_COMMENT_REPLY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createStoryLike] = useMutation(CREATE_STORY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeStory] = useMutation(DELETE_STORY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [updateStoryShare] = useMutation(UPDATE_STORY_SHARE_NO, {
    awaitRefetchQueries: true,
  });

  const [createStoryComment] = useMutation(CREATE_STORY_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [editStoryComment] = useMutation(EDIT_STORY_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteStoryComment] = useMutation(DELETE_STORY_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createStoryCommentLike] = useMutation(CREATE_STORY_COMMENT_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeStoryComment] = useMutation(DELETE_STORY_COMMENT_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createStoryCommentReply] = useMutation(CREATE_STORY_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [editStoryCommentReply] = useMutation(EDIT_STORY_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteStoryCommentReply] = useMutation(DELETE_STORY_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createStoryCommentReplyLike] = useMutation(CREATE_STORY_COMMENT_REPLY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeStoryCommentReply] = useMutation(DELETE_STORY_COMMENT_REPLY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createVideoLike] = useMutation(CREATE_VIDEO_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeVideo] = useMutation(DELETE_VIDEO_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [updateVideoShare] = useMutation(UPDATE_VIDEO_SHARE_NO, {
    awaitRefetchQueries: true,
  });

  const [createVideoComment] = useMutation(CREATE_VIDEO_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [editVideoComment] = useMutation(EDIT_VIDEO_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteVideoComment] = useMutation(DELETE_VIDEO_COMMENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createVideoCommentLike] = useMutation(CREATE_VIDEO_COMMENT_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeVideoComment] = useMutation(DELETE_VIDEO_COMMENT_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createVideoCommentReply] = useMutation(CREATE_VIDEO_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [editVideoCommentReply] = useMutation(EDIT_VIDEO_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteVideoCommentReply] = useMutation(DELETE_VIDEO_COMMENT_REPLY_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [createVideoCommentReplyLike] = useMutation(CREATE_VIDEO_COMMENT_REPLY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [unLikeVideoCommentReply] = useMutation(DELETE_VIDEO_COMMENT_REPLY_LIKE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const encodeText = (text) => {
    return encodeURIComponent(text);
  };

  const handleAddComment = async(comntText) => {
    if (!comntText.trim()) return;
    let commentText = encodeText(comntText);
    let newComment = {};
    if (product.contentType === "Toys"){
      //Save toy comment in database
      const { data, error } =  await createToyComment({
        variables: {
          toyUuid: product.uuid,
          content: commentText,                
        },
      });            
         
      if (error) {
        console.log("Error in creating toy comment", error, data);
        return
      } else {
        console.log("Success in creating toy comment",data);
        newComment = data.createToyComment.toyComment;
      };    
    } else if (product.contentType === "Stories"){
      //Save story comment in database
      const { data, error } =  await createStoryComment({
        variables: {
          storyUuid: product.uuid,
          content: commentText,                
        },
      });            
         
      if (error) {
        console.log("Error in creating story comment", error, data);
        return
      } else {
        console.log("Success in creating story comment",data);
        newComment = data.createStoryComment.storyComment;
      }; 
    } else if (product.contentType === "Videos"){
      //Save video comment in database
      const { data, error } =  await createVideoComment({
        variables: {
          videoUuid: product.uuid,
          content: commentText,                
        },
      });            
         
      if (error) {
        console.log("Error in creating video comment", error, data);
        return
      } else {
        console.log("Success in creating video comment",data);
        newComment = data.createVideoComment.videoComment;
      };
    };
    setProduct(prev => ({
      ...prev,
      comments: [...(prev.comments || []), newComment,],
    }));
    setCommentCount(commentCount + 1);
  };

  const handleAddReply = async(repText, commentUuid) => {
    if (!repText.trim() || !commentUuid) return;
    let replyText = encodeText(repText);
    let newReply = {};
    if (product.contentType === "Toys"){
      //Save toy comment reply in database
      const { data, error } =  await createToyCommentReply({
        variables: {
          toyCommentUuid: commentUuid,
          content: replyText,                
        },
      });            
         
      if (error) {
        console.log("Error in creating toy comment reply", error, data);
        return
      } else {
        console.log("Success in creating toy comment reply",data);
        newReply = data.createToyCommentReply.toyCommentReply;
      };    
    } else if (product.contentType === "Stories"){
      //Save story comment reply in database
      const { data, error } =  await createStoryCommentReply({
        variables: {
          storyCommentUuid: commentUuid,
          content: replyText,                
        },
      });            
         
      if (error) {
        console.log("Error in creating story comment reply", error, data);
        return
      } else {
        console.log("Success in creating story comment reply",data);
        newReply = data.createStoryCommentReply.storyCommentReply;        
      };
    } else if (product.contentType === "Videos"){
      //Save video comment reply in database
      const { data, error } =  await createVideoCommentReply({
        variables: {
          videoCommentUuid: commentUuid,
          content: replyText,                
        },
      });            
         
      if (error) {
        console.log("Error in creating video comment reply", error, data);
        return
      } else {
        console.log("Success in creating video comment reply",data);
        newReply = data.createVideoCommentReply.videoCommentReply;
      };
    };    

    setProduct(prev => ({
      ...prev,
      comments: product.comments.map(comment =>
        comment.uuid === commentUuid
        ? {
            ...comment,
            replies: 
              [...(comment.replies || []), 
              newReply],
          }
        : comment
      ),
    }));
  };

  const handleDeleteComment = async(commentUuid) => {
    if (!commentUuid) return;
    if (product.contentType === "Toys"){
      const { data, error } =  await deleteToyComment({
        variables: {
          toyCommentUuid: commentUuid,                
        },
      });

      if (error) {
        console.log("Error in delete toy comment", error, data);
        return
      } else {
        console.log("Success in delete toy comment",data);
      };
    } else if (product.contentType === "Stories"){
      const { data, error } =  await deleteStoryComment({
        variables: {
          storyCommentUuid: commentUuid,                
        },
      });

      if (error) {
        console.log("Error in delete story comment", error, data);
        return
      } else {
        console.log("Success in delete story comment",data);
      };
    } else if (product.contentType === "Videos"){
      const { data, error } =  await deleteVideoComment({
        variables: {
          videoCommentUuid: commentUuid,                
        },
      });

      if (error) {
        console.log("Error in delete video comment", error, data);
        return
      } else {
        console.log("Success in delete video comment",data);
      };
    };

    setProduct(prev => ({
      ...prev,
      comments: prev.comments.filter(c => c.uuid !== commentUuid),
    }));
    setCommentCount(commentCount - 1);
  };

  const handleDeleteReply = async(
    commentUuid, 
    replyUuid
  ) => {
    if (!commentUuid || !replyUuid) return;
    if (product.contentType === "Toys"){
      const { data, error } =  await deleteToyCommentReply({
        variables: {
          toyCommentReplyUuid: replyUuid,                
        },
      });

      if (error) {
        console.log("Error in delete toy comment reply", error, data);
        return
      } else {
        console.log("Success in delete toy comment reply",data);
      };
    } else if (product.contentType === "Stories"){
      const { data, error } =  await deleteStoryCommentReply({
        variables: {
          storyCommentReplyUuid: replyUuid,                
        },
      });

      if (error) {
        console.log("Error in delete story comment reply", error, data);
        return
      } else {
        console.log("Success in delete story comment reply",data);
      };
    } else if (product.contentType === "Videos"){
      const { data, error } =  await deleteVideoCommentReply({
        variables: {
          videoCommentReplyUuid: replyUuid,                
        },
      });

      if (error) {
        console.log("Error in delete video comment reply", error, data);
        return
      } else {
        console.log("Success in delete video comment reply",data);
      };
    };

    setProduct(prev => ({
      ...prev,
      comments: prev.comments.map(comment =>
        comment.uuid === commentUuid
        ? {
            ...comment,
            replies: comment.replies.filter(
              reply => reply.uuid !== replyUuid
            ),
          }
        : comment
      ),
    }));
  };

  const handleEditComment = async(commentUuid, newEditText) => {
    if (!commentUuid || !newEditText.trim()) return;
    let newText = encodeText(newEditText);
    if (product.contentType === "Toys"){
      const { data, error } =  await editToyComment({
        variables: {
          toyCommentUuid: commentUuid,
          content: newText,                
        },
      });            
         
      if (error) {
        console.log("Error in editing toy comment", error, data);
        return
      } else {
        console.log("Success in editing toy comment",data);
      };
    } else if (product.contentType === "Stories"){
      //Edit story comment in database
      const { data, error } =  await editStoryComment({
        variables: {
          storyCommentUuid: commentUuid,
          content: newText,                
        },
      });            
         
      if (error) {
        console.log("Error in editing story comment", error, data);
        return
      } else {
        console.log("Success in editing story comment",data);
      };
    } else if (product.contentType === "Videos"){
      //Edit video comment in database
      const { data, error } =  await editVideoComment({
        variables: {
          videoCommentUuid: commentUuid,
          content: newText,                
        },
      });            
         
      if (error) {
        console.log("Error in editing video comment", error, data);
        return
      } else {
        console.log("Success in editing video comment",data);
      };
    };

    setProduct(prev => ({
      ...prev,
      comments: prev.comments.map(c =>
        c.uuid === commentUuid ? { ...c, content: newText } : c
      ),
    }));
  };

  const handleEditReply = async(
    commentUuid,
    replyUuid, 
    newEditText
  ) => {
    if (!commentUuid || !replyUuid || !newEditText.trim()) return;
    let newText = encodeText(newEditText);
    if (product.contentType === "Toys"){
      //Edit toy comment reply in database
      const { data, error } =  await editToyCommentReply({
        variables: {
          toyCommentReplyUuid: replyUuid,
          content: newText,                
        },
      });            
         
      if (error) {
        console.log("Error in editing toy reply comment", error, data);
        return
      } else {
        console.log("Success in editing toy reply comment",data);
      };
    } else if (product.contentType === "Stories"){
      //Edit story comment reply in database
      const { data, error } =  await editStoryCommentReply({
        variables: {
          storyCommentReplyUuid: replyUuid,
          content: newText,                
        },
      });            
         
      if (error) {
        console.log("Error in editing story comment reply", error, data);
        return
      } else {
        console.log("Success in editing story comment reply",data);
      };
    } else if (product.contentType === "Videos"){
      //Edit video comment reply in database
      const { data, error } =  await editVideoCommentReply({
        variables: {
          videoCommentReplyUuid: replyUuid,
          content: newText,                
        },
      });            
         
      if (error) {
        console.log("Error in editing video comment reply", error, data);
        return 
      } else {
        console.log("Success in editing video comment reply",data);
      };
    };
    
    setProduct(prev => ({
      ...prev,
      comments: prev.comments.map(comment =>
        comment.uuid === commentUuid
        ? {
          ...comment,
          replies: comment.replies.map(reply =>
            reply.uuid === replyUuid
            ? { ...reply, content: newText }
            : reply
          ),
        }
      : comment
      ),
    }));
  };

  const handleCommentLikeUpdate = async(
    commentUuid,
    isLiked,
  ) => {
    if (product.contentType === "Toys"){
      //save toy comment like/unlike in database
      if (isLiked){
        const { data, error } =  await createToyCommentLike({
          variables: {
            toyCommentUuid: commentUuid,
          },
        });            
           
        if (error) {
          console.log("Error in create toy comment like", error, data);
          return
        } else {
          console.log("Success in create toy comment like",data);
        };
      } else {
        const { data, error } =  await unLikeToyComment({
          variables: {
            toyCommentUuid: commentUuid,
          },
        });

        if (error) {
          console.log("Error in delete toy comment like", error, data);
          return
        } else {
          console.log("Success in delete toy comment like",data);
        };
      };
    } else if (product.contentType === "Stories"){
      //save story comment like/unlike in database
      if (isLiked){
        const { data, error } =  await createStoryCommentLike({
          variables: {
            storyCommentUuid: commentUuid,
          },
        });            
           
        if (error) {
          console.log("Error in create story comment like", error, data);
          return
        } else {
          console.log("Success in create story comment like",data);
        };
      } else {
        const { data, error } =  await unLikeStoryComment({
          variables: {
            storyCommentUuid: commentUuid,
          },
        });

        if (error) {
          console.log("Error in delete story comment like", error, data);
          return
        } else {
          console.log("Success in delete story comment like",data);
        };
      };
    } else if (product.contentType === "Videos"){
      //save video comment like/unlike in database
      if (isLiked){
        const { data, error } =  await createVideoCommentLike({
          variables: {
            videoCommentUuid: commentUuid,                
          },
        });            
           
        if (error) {
          console.log("Error in create video comment like", error, data);
          return
        } else {
          console.log("Success in create video comment like",data);
        };
      } else {
        const { data, error } =  await unLikeVideoComment({
          variables: {
            videoCommentUuid: commentUuid,
          },
        });

        if (error) {
          console.log("Error in delete video comment like", error, data);
          return
        } else {
          console.log("Success in delete video comment like",data);
        };
      };
    };

    setProduct(prev => ({
      ...prev,
      comments: prev.comments.map(comment =>
        comment.uuid === commentUuid
        ? {
            ...comment,
            isLiked,
            likeNo: isLiked 
            ? comment.likeNo + 1
            : comment.likeNo > 0
            ? comment.likeNo - 1
            : 0,
          }
        : comment
      ),
    }));
  };

  const handleCommentReplyLikeUpdate = async(
    commentUuid,
    commentReplyUuid,
    isLiked,
  ) => {
    if (product.contentType === "Toys"){
      //save toy comment reply like/unlike in database
      if (isLiked){
        const { data, error } =  await createToyCommentReplyLike({
          variables: {
            toyCommentReplyUuid: commentReplyUuid,
          },
        });            
           
        if (error) {
          console.log("Error in create toy comment reply like", error, data);
          return
        } else {
          console.log("Success in create toy comment reply like",data);
        };
      } else {
        const { data, error } =  await unLikeToyCommentReply({
          variables: {
            toyCommentReplyUuid: commentReplyUuid,
          },
        });

        if (error) {
          console.log("Error in delete toy comment reply like", error, data);
          return
        } else {
          console.log("Success in delete toy comment reply like",data);
        };
      };
    } else if (product.contentType === "Stories"){
      //save story comment reply like/unlike in database
      if (isLiked){
        const { data, error } =  await createStoryCommentReplyLike({
          variables: {
            storyCommentReplyUuid: commentReplyUuid,
          },
        });            
           
        if (error) {
          console.log("Error in create story comment reply like", error, data);
          return
        } else {
          console.log("Success in create story comment reply like",data);
        };
      } else {
        const { data, error } =  await unLikeStoryCommentReply({
          variables: {
            storyCommentReplyUuid: commentReplyUuid,
          },
        });

        if (error) {
          console.log("Error in delete story comment reply like", error, data);
          return
        } else {
          console.log("Success in delete story comment reply like",data);
        };
      };
    } else if (product.contentType === "Videos"){
      //save video comment reply like/unlike in database
      if (isLiked){
        const { data, error } =  await createVideoCommentReplyLike({
          variables: {
            videoCommentReplyUuid: commentReplyUuid,                
          },
        });            
           
        if (error) {
          console.log("Error in create video comment reply like", error, data);
          return
        } else {
          console.log("Success in create video comment reply like",data);
        };
      } else {
        const { data, error } =  await unLikeVideoCommentReply({
          variables: {
            videoCommentReplyUuid: commentReplyUuid,
          },
        });

        if (error) {
          console.log("Error in delete video comment reply like", error, data);
          return
        } else {
          console.log("Success in delete video comment reply like",data);
        };
      };
    };

    setProduct(prev => ({
      ...prev,
      comments: prev.comments &&
      prev.comments.map(comment =>
        comment.uuid === commentUuid
        ? {
            ...comment,
            replies: comment.replies &&
            comment.replies.map(commentReply =>
              commentReply.uuid === commentReplyUuid
              ? {
                  ...commentReply,
                  isLiked,
                  likeNo: isLiked ?
                    commentReply.likeNo + 1
                  : commentReply.likeNo > 0
                    ? commentReply.likeNo - 1
                    : 0,
                }
              : commentReply
            ),
          }
        : comment
      ),
    }));    
  };

  // Handle cancel removal
  const handleCloseCommentDlg = () => {
    setCommentDialog({ open: false });
  };

  const handleFavoriteToggle = async() => {
    if (product.contentType === "Toys"){
      //save toy like/unlike in database
      if (!isFavorited){
        const { data, error } =  await createToyLike({
          variables: {
            toyUuid: product.uuid,                
          },
        });            
           
        if (error) {
          console.log("Error in create toy like", error, data);             
        } else {
          console.log("Success in create toy like",data);
          setIsFavorited(!isFavorited);
          setLikeCount((prevCount) => (isFavorited ? prevCount - 1 : prevCount + 1));
        };
      } else {
        const { data, error } =  await unLikeToy({
          variables: {
            toyUuid: product.uuid,                
          },
        });

        if (error) {
          console.log("Error in delete toy like", error, data);      
        } else {
          console.log("Success in delete toy like",data);
          setIsFavorited(!isFavorited);
          setLikeCount((prevCount) => (isFavorited ? prevCount - 1 : prevCount + 1));
        };
      };    
    } else if (product.contentType === "Stories"){
      //save story like/unlike in database
      if (!isFavorited){
        const { data, error } =  await createStoryLike({
          variables: {
            storyUuid: product.uuid,                
          },
        });            
           
        if (error) {
          console.log("Error in create story like", error, data);             
        } else {
          console.log("Success in create story like",data);
          setIsFavorited(!isFavorited);
          setLikeCount((prevCount) => (isFavorited ? prevCount - 1 : prevCount + 1));
        };
      } else {
        const { data, error } =  await unLikeStory({
          variables: {
            storyUuid: product.uuid,                
          },
        });

        if (error) {
          console.log("Error in delete story like", error, data);      
        } else {
          console.log("Success in delete story like",data);
          setIsFavorited(!isFavorited);
          setLikeCount((prevCount) => (isFavorited ? prevCount - 1 : prevCount + 1));
        };
      };
    } else if (product.contentType === "Videos"){
      //save video like/unlike in database
      if (!isFavorited){
        const { data, error } =  await createVideoLike({
          variables: {
            videoUuid: product.uuid,                
          },
        });            
           
        if (error) {
          console.log("Error in create video like", error, data);             
        } else {
          console.log("Success in create video like",data);
          setIsFavorited(!isFavorited);
          setLikeCount((prevCount) => (isFavorited ? prevCount - 1 : prevCount + 1));
        };
      } else {
        const { data, error } =  await unLikeVideo({
          variables: {
            videoUuid: product.uuid,                
          },
        });

        if (error) {
          console.log("Error in delete video like", error, data);      
        } else {
          console.log("Success in delete video like",data);
          setIsFavorited(!isFavorited);
          setLikeCount((prevCount) => (isFavorited ? prevCount - 1 : prevCount + 1));
        };
      };
    };
  };

  const handleFollowButtonClick = async() => {
    if (product.userId.isFollowing) {
      // Show unfollow confirmation popup
      setUnfollowPopup({
        open: true,
        followerId: product.userId.userId,
        followerName: product.userId.username,
      });
    } else {
      //save follow to database
      const { data, error } =  await createFollow({
        variables: {
          userUuid: product.userId.userUuid,                
        },
      });            
      if (error) {
        console.log("Error", error, data);              
      } else {
        console.log("Success",data); 
        setUnfollowPopup({ open: false, followerId: null, followerName: "" });
        onFollowToggle(!product.userId.isFollowing);           
      }
    };    
  };

  const handleConfirmUnfollow = async() => {
    //save unfollow to database        
    const { data, error } =  await unFollow({
      variables: {
        userUuid: product.userId.userUuid,                
      },
    });

    if (error) {
      console.log("Error", error, data);      
    } else {
      console.log("Success",data);
      setUnfollowPopup({ open: false, followerId: null, followerName: "" });
      onFollowToggle(!product.userId.isFollowing);            
    };
  };

 const handleCancelUnfollow = () => {
    setUnfollowPopup({ open: false, followerId: null, followerName: "" });
  };

  const handleShareDialogOpen = () => {
    product.shareUrl && setShareDialog({ open: true });   
  };

  const handleToyShareSuccess  = async() => {
    if (!product.uuid) return
    if (product.contentType === "Toys"){    
      const { data, error } =  await updateToyShare({
        variables: {
          toyUuid: product.uuid,                
        },
      });            
           
      if (error) {
        console.log("Error in updating toy share", error, data);             
      } else {
        console.log("Success in updating toy share",data);
        onShareClick(product.id);
      };
    } else if (product.contentType === "Stories"){
      const { data, error } =  await updateStoryShare({
        variables: {
          storyUuid: product.uuid,                
        },
      });            
           
      if (error) {
        console.log("Error in updating story share", error, data);             
      } else {
        console.log("Success in updating story share",data);
        onShareClick(product.id);
      };
    } else if (product.contentType === "Videos"){
      const { data, error } =  await updateVideoShare({
        variables: {
          videoUuid: product.uuid,                
        },
      });            
           
      if (error) {
        console.log("Error in updating video share", error, data);             
      } else {
        console.log("Success in updating video share",data);
        onShareClick(product.id);
      };
    };    
  };

  const handleShareDialogClose = () => {
    setShareDialog({ open: false });
  };

  // Define styling based on content type
  const getCardStyling = (contentType) => {
    switch (contentType) {
      case "Stories":
        return {
          borderColor: "#01579B",
          backgroundColor: "#E1F5FE",
        };
      case "Videos":
        return {
          borderColor: "#EFB561", // Orange for videos
          backgroundColor: "#FCF2E3", // Light orange background
        };
      default:
        // Toys
        return {
          borderColor: "#4caf50",
          backgroundColor: "#E5F5EC",
        };
    }
  };

  const { borderColor, backgroundColor } = getCardStyling(product.contentType);

  return (
    <Card
      sx={{
        maxWidth: 360,
        height: "100%", // Ensure all cards have same height
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${borderColor}`,
        borderRadius: "12px",
        boxShadow: "none",
        zIndex: -1,
      }}
    >
      {/* User Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 1,
          px: 1,
          backgroundColor: backgroundColor,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <UserCard
            user={product.userId}
            onUsernameClick={onUserProfileNavigation}
            onFullNameClick={onUserProfileNavigation}
            type="avatar"
            context="card"
          >
            <Avatar
              src={product.userId.avatarFileName}

            />
          </UserCard>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <UserCard
              user={product.userId}
              onUsernameClick={onUserProfileNavigation}
              onFullNameClick={onUserProfileNavigation}
              type="username"
              context="card"
            >
              <Typography
                variant="body2"
                fontWeight="bold"
              >
                {product.userId.username}
              </Typography>
            </UserCard>
            <Typography variant="caption" color="text.secondary">
              {product.userId.time}
            </Typography>
          </Box>
        </Box>

        {product.userId.userUuid !== userUuid && (
          <FollowButton
            isFollowing={isFollowing}
            onToggle={handleFollowButtonClick}
          />
        )}
      </Box>

      {product.img && (
        <Box sx={{ position: "relative" }}>
            <CardMedia
              component="img"
              image={product.img}
              alt={product.title}
            />
          </Box>
      )}

      
      {/* Product Info */}
      <CardContent
        sx={{
          pb: 1,
          backgroundColor: backgroundColor,
          flexGrow: 1, // Allow content to grow and fill available space
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TruncatedTooltip title={product.title}>

        <Link component={RouterLink} 
          to={
              product.contentType === "Stories"
                ? `/story/${product.uuid}`
                : product.contentType === "Videos"
                ? `/video/${product.uuid}`
                : `/toy/${product.uuid}`
            }        
        color="black" underline="none">{product.title}</Link></TruncatedTooltip>

        {/* Description - Show if available */}
        {product.description && (
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              mt: 2,
              fontSize: "14px",
              lineHeight: 1.4,
            }}
          >
            {product.description}
          </Typography>
        )}

        {/* Content - Show if available */}
        {product.content &&
         product.content.length > (product.img ? 100 : 400 ) ? (
          <Box sx={{
                 flexGrow: 1,
                 overflow: "hidden",
                 maxHeight: product.img ? "120px" : "350px"
          }}>
            <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: 1.4,
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {product.content.substring(0, (product.img ? 100 : 400))}...{" "}
                      <Link component={RouterLink} 
                        to={
                          product.contentType === "Stories"
                          ? `/story/${product.uuid}`
                          : product.contentType === "Videos"
                          ? `/video/${product.uuid}`
                          : `/toy/${product.uuid}`
                        }        
                        color="blue" underline="none">more</Link>
            </Typography>
          </Box>
          ) : (
          <Box
            sx={{
              maxHeight: product.img ? "120px" : "350px",
              overflowY: "auto",
              overflowX: "hidden",
              flexGrow: 1,
              mb: 3,
              pr: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#666",
                mt: 2,
                fontSize: "14px",
                lineHeight: 1.4,
              }}
            >
              {product.content}
            </Typography>
          </Box>
        )}

        {/* Price section - Only show for Toys */}
        {product.contentType === "Toys" && (
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{
              mt: 1,
            }}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ color: "black" }}>
              {product.price
                ? product.price.toLocaleString(undefined, {
                    style: "currency",
                    currency: "USD",
                  })
                : ""}
            </Typography>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                textDecoration: "line-through",
                color: "#9e9e9e",
              }}
            >
              {product.oldPrice
                ? product.oldPrice.toLocaleString(undefined, {
                    style: "currency",
                    currency: "USD",
                  })
                : ""}
            </Typography>
          </Box>
        )}
        {/* Category section - Only show for Toys */}
        {product.contentType === "Toys" && (
          <Box display="flex" alignItems="center" gap={1}>
            <Typography
              variant="caption"
              sx={{
                color: "#757575",
              }}
            >
              {product.category}
            </Typography>
          </Box>
        )}
        {/* Buy Button - Only show for Toys */}
        {product.contentType === "Toys" && (
          <Box pt={1} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              startIcon={<ShoppingCartIcon />}
              sx={{
                backgroundColor: "#04A15B",
                "&:hover": {
                  backgroundColor: "#1b5e20",
                },
                textTransform: "none",
              }}
            >
              BUY
            </Button>
          </Box>
        )}
      </CardContent>

      <Divider />

      {/* Footer */}
      <CardActions
        sx={{
          justifyContent: "space-between",
          px: 2,
          pb: 1,
          backgroundColor: backgroundColor,
        }}
      >
        {/* Likes & Comments */}
        <Box display="flex" alignItems="center">
          <StyledTooltip
            title={isFavorited ? "Click to undo like" : "Click to like"}
          >
            <IconButton
              size="small"
              onClick={handleFavoriteToggle}
              aria-label={
                isFavorited ? "Remove from favorites" : "Add to favorites"
              }
              sx={{
                color: isFavorited ? "#EF5658" : "#9e9e9e",
                p: 0,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              {isFavorited ? (
                <FavoriteIcon fontSize="small" />
              ) : (
                <FavoriteBorderOutlinedIcon fontSize="small" />
              )}
            </IconButton>
          </StyledTooltip>
          <LikesPopup users={product.likedUsers}>
            <Typography
              variant="caption"
              sx={{ 
                color: "#9e9e9e",
                ml: 0.5, 
                minWidth: "12px",
                cursor: "pointer", 
              }}
            >
              {likeCount}
            </Typography>
          </LikesPopup>
          <StyledTooltip title="View/Add comments">
            <IconButton
              size="small"
              sx={{
                color: "#9e9e9e",
                ml: 2,
                p: 0,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
              onClick={() => setCommentDialog({ open: true })}
            >
              <ModeCommentOutlinedIcon fontSize="small" />
            </IconButton>
          </StyledTooltip>

          <Typography variant="caption" sx={{ color: "#9e9e9e", ml: 0.5 }}>
            {commentCount}
          </Typography>          

          <StyledTooltip title="Share this item">
            <IconButton
              size="small"
              sx={{
                color: "#9e9e9e",
                ml: 2,
                p: 0,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
              onClick={handleShareDialogOpen}
            >
              <ShareOutlinedIcon fontSize="small" />
            </IconButton>
          </StyledTooltip>
          <Typography variant="caption" sx={{ color: "#9e9e9e", ml: 0.5 }}>
            {product.shares || 0}
          </Typography>

          <StyledTooltip
            title={
              isBookmarked
                ? "Remove from your collection"
                : "Add to your collection"
            }
          >
            <IconButton
              onClick={() => onBookmarkClick(product.id, isBookmarked, product.contentType)}
              sx={{
                p: 0,
                ml: 2,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              {isBookmarked ? (
                <CollectionsBookmarkIcon
                  fontSize="small"
                  sx={{ color: "#000" }}
                />
              ) : (
                <CollectionsBookmarkOutlinedIcon
                  fontSize="small"
                  sx={{ color: "#9e9e9e" }}
                />
              )}
            </IconButton>
          </StyledTooltip>
        </Box>

        {/* Action Button - Different for each content type */}
        {product.contentType === "Toys" && (
          <IconButton
            sx={{
              backgroundColor: "#04A15B",
              color: "white",
              borderRadius: "6px",
              p: "3px",
              pointerEvents: "none",
              cursor: "default",
            }}
          >
            <ShoppingCartIcon fontSize="small" />
          </IconButton>
        )}

        {product.contentType === "Stories" && (
          <IconButton
            sx={{
              backgroundColor: "#01579B",
              color: "white",
              borderRadius: "6px",
              p: "3px",
              pointerEvents: "none",
              cursor: "default",
            }}
          >
            <AutoStoriesOutlinedIcon fontSize="small" />
          </IconButton>
        )}

        {product.contentType === "Videos" && (
          <IconButton
            sx={{
              backgroundColor: "#EFB561",
              color: "white",
              borderRadius: "6px",
              p: "3px",
              pointerEvents: "none",
              cursor: "default",
            }}
          >
            <VideocamOutlinedIcon fontSize="small" />
          </IconButton>
        )}
      </CardActions>

      {/* Unfollow Confirmation Popup */}
          <AlertPopup
            open={unfollowPopup.open}
            title="Unfollow This Person"
            message={
              <>
                Are you sure you want to unfollow user{" "}
                <strong>{unfollowPopup.followerName}</strong>?
              </>
            }
            confirmText="YES, UNFOLLOW"
            cancelText="CANCEL"
            onConfirm={handleConfirmUnfollow}
            onCancel={handleCancelUnfollow}
            onClose={handleCancelUnfollow}
            showCheckCircle={true}
          />

      <CommentDialog
        open={commentDialog.open}
        product={product}
        comments={product && product.comments 
                  ? product.comments 
                  : []
                  }
        onAddComment={(text) => handleAddComment(text)}
        onAddReply={(reply, commentUuid) =>
          handleAddReply(reply, commentUuid)
        }
        onFollowChange={handleFollowButtonClick}
        onCommentLikeToggle={(newLikeState, commentUuid) =>
          handleCommentLikeUpdate(
            commentUuid, newLikeState,
          )
        }
        onCommentReplyLikeToggle={(
          newLikeState,
          commentUuid,
          commentReplyUuid
        ) =>
          handleCommentReplyLikeUpdate(
            commentUuid,
            commentReplyUuid,
            newLikeState,
          )
        }
        onDeleteComment={(commentUuid) =>
          handleDeleteComment(commentUuid)
        }
        onDeleteReply={(commentUuid, replyUuid) =>
          handleDeleteReply(commentUuid, replyUuid)
        }
        onEditComment={(commentUuid, newText) =>
          handleEditComment(commentUuid,newText)
        }
        onEditReply={(commentUuid, replyUuid, newText) =>
          handleEditReply(commentUuid, replyUuid, newText)
        }
        onClose={handleCloseCommentDlg }
      />

      {/* Share Popup - Only render if shareUrl is provided */}
      {product.shareUrl && (
        <SharePopup
          open={shareDialog.open}
          onClose={handleShareDialogClose}
          shareUrl={product.shareUrl}
          contentTitle={product.title}
          onEmailShareSuccess={handleToyShareSuccess}
        />
      )}
    </Card>
  );
};

export default ProductCard;
